module.exports = __webpack_public_path__ + "static/media/man_double_expo.9e614f13.png";